import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFormatIndentDecreaseComponent } from "./med-icon-format-indent-decrease.component";

@NgModule({
  declarations: [
    MedIconFormatIndentDecreaseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFormatIndentDecreaseComponent,
  ],
})
export class MedIconFormatIndentDecreaseModule { }
